import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import pickExcept from 'utils/pickExcept';

import ContentWizardDialog from './contentWizardDialog';

const ContentWizardContext = createContext();

export const ContentWizardContextProvider = props => {
  const [isOpen, setIsOpen] = useState(props.isVisible);
  const [params, setParams] = useState();

  const close = () => {
    setParams();
    setIsOpen(false);
  };

  const open = (config = {}) => {
    setParams(config);
    setIsOpen(true);
  };

  return (
    <ContentWizardContext.Provider value={{ closeDialog: close, openDialog: open }}>
      {props.children}
      {params && (
        <ContentWizardDialog
          params={pickExcept(params, 'type')}
          close={close}
          isOpen={isOpen}
          type={params.type}
        />
      )}
    </ContentWizardContext.Provider>
  );
};

ContentWizardContextProvider.propTypes = {
  children: PropTypes.node,
  isVisible: PropTypes.bool,
};

ContentWizardContextProvider.defaultProps = {
  children: null,
  isVisible: false,
};

const useContentWizardContext = () => {
  return useContext(ContentWizardContext);
};

export default useContentWizardContext;
